module.exports = __webpack_public_path__ + "static/FabrigaLight-94f4d914a5199bd352c250e1af34fa77.woff";